import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import Box from "@mui/material/Box";
import ConfirmationWithDescription from "src/components/ConfirmationWithDescription";
import { ReactVideoPlayer } from "src/components";
import { BlockFooter, CompleteCheck } from "./component/WorkoutBlockParts";

const VideoUI = ({
  inputs,
  setInputs,
  setModalChangeExe,
  setIsWorkoutCompleted,
  practiceType,
  handleSubmit,
  comment_data,
}) => {
  const [openExerciseAlert, setOpenExerciseAlert] = useState(false);

  const handleChangeComplete = (e) => {
    const { checked } = e.target;
    if (!checked) {
      setOpenExerciseAlert(true);
      return;
    }

    setInputs({
      ...inputs,
      ["is_completed"]: checked,
    });
    if (checked) {
      handleSubmit(true, true);
    }
  };
  const handleAgreeInExerciseSet = () => {
    setIsWorkoutCompleted(false);
    setModalChangeExe(true);
    setOpenExerciseAlert(false);
    setInputs({
      ...inputs,
      ["is_completed"]: false,
    });
  };

  return (
    <div className="my-2">
      <ConfirmationWithDescription
        open={openExerciseAlert}
        setOpen={setOpenExerciseAlert}
        title={"Are you sure you want to take this action?"}
        descriotion={`If you uncheck, your points or coins allocated for this ${practiceType} will be deducted.`}
        handleAgree={handleAgreeInExerciseSet}
        isJustForOk={false}
      />
      <div className="characters mt-2">
        <div className="row justify-content-center">
          <div className="col-sm-12 col-md-12">
            {practiceType === "comment" ? (
              <TextField
                id="comment-text"
                label="Comment"
                placeholder="Comment"
                variant="outlined"
                fullWidth
                multiline
                rows={6}
                name="comment"
                value={comment_data?.editData?.comment}
                disabled
              />
            ) : (
              // Not wider than 800px (a full-width 16:9 player was taller than the popup).
              <Box sx={{ width: "100%", maxWidth: 800, mx: "auto" }}>
                <ReactVideoPlayer url={inputs.video_url} compactFailed />
              </Box>
            )}

            {/* Same footer as the workout blocks: Mark as complete on the right. */}
            <BlockFooter
              complete={
                <CompleteCheck
                  checked={inputs?.is_completed ? inputs?.is_completed : false}
                  onChange={(e) => handleChangeComplete(e)}
                />
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default VideoUI;
